import script from "./SortSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./SortSelect.vue?vue&type=script&lang=ts&setup=true"

import "./SortSelect.vue?vue&type=style&index=0&id=66630659&lang=scss&scoped=true"
import "./SortSelect.vue?vue&type=style&index=1&id=66630659&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66630659"]])

export default __exports__